import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import CouponsList from '../component/fpg/list/CouponsList'
import FilterActiveIcon from '../icons/filteractiveicon'
import FilterIcon from '../icons/filtericon'
import PlusIcon from '../icons/plusicon'
import MainLayout from '../mainLayout'
//moment import
import moment from "moment";
//Service import
import service from "../services";
//Redux Connect
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActCreators } from "../redux/bindActionCretor";
import commonImage from "../commonImage";

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(ActCreators, dispatch);
};
let sub;
class Couponlist extends Component {
    constructor(props) {
        super(props)

        this.state = {
            getLastUpdated: '',
            loaderFlag: false,
            successmodal: false,
            totalAddedRecord: 0,
            data: [
                {
                    "label": "DISCOUNT list",
                    "Content": "This is content for Tab 1",
                }
            ]
        }
        this.apiserve = new service();
    }


    getAllCouponEvent = () => {
        sub = this.apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                case "ticketCms|coupons|getList":
                    this.setState(
                        {
                            getAllCouponListDetails: response.data,
                            //   getAllCouponListtotaldocs: response.data.docs,
                            //   pageCount: Math.ceil(
                            //     response.data.totalDocs / this.state.perPage
                            //   ),
                        },
                        () => {
                            this.setState({
                                loaderFlag: false,
                                // pageCount: Math.ceil(
                                //   response.data.totalDocs / this.state.perPage
                                // ),
                            });
                        }
                    );
                    break;
            }
        });
    };
    componentDidMount() {
        this.getCouponLastUpdate();
        this.getLastUpdatedTimeandDate();
        this.setState({
            loaderFlag: true,
        });
    }

    // componentDidUpdate() {
    //     this.getCouponLastUpdate();
    //     this.getAllCouponEvent();
    // }

    getCouponLastUpdate = () => {
        sub = this.apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                case 'ticketCms|coupons|getLastUpdated':
                    this.setState({
                        getLastUpdated: response.data
                    })
                    break;
                 case 'ticketCms|coupons|importCsv':
                    if (!response.error) {
                        this.setState({
                            fileUploadingGeneral: false,
                            totalAddedRecord: response.data.totalAddedRecord
                        }, () => {
                            this.setState({
                                successmodal: true,
                            })
                        })
                        if (response.data.totalAddedRecord > 0) {
                            var data = {
                                page: 1,
                                limit: 50
                            }
                            this.apiserve.sendevent("ticketCms|coupons|getList", data);
                        }
                    }
                    else {
                        this.apiserve.error(response.data.error)
                    }
                    break;
            }
        })
    }

    componentWillUnmount = () => {
        sub.unsubscribe();
    }

    uploadCSVGeneral = (e) => {
        this.setState({
            fileUploadingGeneral: true
        })
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = (event) => {
            setTimeout(() => {
                this.imageUploadScreenGeneral(file,event.target.result);
            }, 0);
        };
    }
    imageUploadScreenGeneral = (file,img) => {
        var fileSet = commonImage(file,false,'',img)
        fileSet.then((value) => {
            var data1 = {
                url: encodeURI(process.env.REACT_APP_IMAGE_URL + value)
            }
            this.apiserve.sendevent("ticketCms|coupons|importCsv", data1);
        });

    };

    getLastUpdatedTimeandDate = () => {
        this.apiserve.sendevent("ticketCms|coupons|getLastUpdated", { type: 1 });
    }

    cleare = () => {
        this.apiserve.sendevent("ticketCms|coupons|findProductName",{});
        this.props.CouponEditList('');
        this.props.history.push('/discount-detail');
    }

    CloseModal = () => {
        this.setState({
            successmodal: false
        })
    }
    // TabClick = () => {
    //     this.props.history.push('/discount-detail')
    // }
    render() {
        const { getLastUpdated, getAllCouponListDetails } = this.state;
        var updateAt = new Date(getLastUpdated && getLastUpdated.updatedAt);
        var hour = moment(updateAt).format("h");
        var minutes = moment(updateAt).format("mm");
        var state = moment(updateAt).format("A");
        var updatedBy = getLastUpdated && getLastUpdated.updatedBy;
        return (
            <React.Fragment>
                <div className="right_side_wrapper ">
                    <ul className="fpg_admin_tab disp_flex">
                        {
                            this.state.data && this.state.data.map((list, index) => {
                                return (
                                    <li className="active" key={index}>
                                        <p className="uppercase text_left">
                                            <div>{list.label}</div>
                                            <span id={index} onClick={() => this.cleare()}>
                                                <PlusIcon />
                                            </span>
                                        </p>
                                    </li>
                                )
                            })
                        }
                    </ul>

                    {/* <div className="back_date d_flex d_flex_align_center d_flex_justify_spacebt">
                        <p></p>
                        <p className="update_date">Last Update: {hour}:{minutes} {state} -{" "}
                        {moment(updateAt).format("MM/DD/YYYY")} Last Updated By:{" "}
                        {updatedBy && updatedBy.fname} {updatedBy && updatedBy.lname}</p>
                    </div> */}
                    <div className="relative" style={{ height: "calc(100% - 60px)" }}>
                        <CouponsList history={this.props.history} />
                    </div>
                    {/* For CSV upload successfully */}
                    <div className={`user_popup ${this.state.successmodal ? "active" : null}`}>
                        <span className="popup_overlay" onClick={this.CloseModal}></span>
                        <div className="sundance_popup_detail box_shadow approve_success_popup bg_white">
                            <div className="approve_popup_header text_center relative">
                                <p>You have successfully uploaded {this.state.totalAddedRecord} {this.state.totalAddedRecord === 0 || this.state.totalAddedRecord === 1 ? 'Discount' : 'Discounts'}</p>
                            </div>
                            <div className="content">
                                <div className="field_row text_center">
                                    <button className="small_btn active" onClick={this.CloseModal}>OK</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Couponlist)